'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setIf = exports.setIn = exports.push = exports.set = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _freeze = require('./freeze');

var _freeze2 = _interopRequireDefault(_freeze);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var set = exports.set = function set(name, value) {
  return function (obj) {
    obj = _extends({}, obj);
    obj[name] = value;
    return obj;
  };
};

var push = exports.push = function push(name, value) {
  return function (obj) {
    return set(name, [].concat(_toConsumableArray(obj[name] || []), [value]))(obj);
  };
};

var defaultForPath = function defaultForPath(path) {
  return typeof path[0] === 'string' || path[0] instanceof String || _typeof(path[0]) === 'symbol' ? (0, _freeze2.default)({}) : (0, _freeze2.default)([]);
};

var setIn = exports.setIn = function setIn(path, value) {
  return function () {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultForPath(path);
    return path.length === 1 ? set(path[0], value)(obj) : set(path[0], setIn(path.slice(1), value)(obj[path[0]]))(obj);
  };
};

var resolvePredicate = function resolvePredicate(predicate, options) {
  return typeof predicate === 'function' ? predicate(options) : predicate;
};

var getValue = function getValue(v) {
  return typeof v === 'function' ? v() : v;
};

var setIf = exports.setIf = function setIf(predicate, propertyName, valueOrFn) {
  return function (obj) {
    return resolvePredicate(predicate, obj) ? set(propertyName, getValue(valueOrFn))(obj) : obj;
  };
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hub-http/static-1.117/js/helpers/update.js
// module id = 48
// module chunks = 0 1